import { UserRole } from '@klubovna/api-client';

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: UserRole;
  createdAt: string;
  updatedAt: string;
  phoneNumber: string | null;
  bio?: string | null;
  profilePhoto?: string | null;
  mustChangePassword?: boolean;
  isActive?: boolean;
  documentCount?: number;
}

export interface UsersState {
  users: User[];
  loading: boolean;
  error: string | null;
  selectedUser: User | null;
  pagination: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
}

export const initialUsersState: UsersState = {
  users: [],
  loading: false,
  error: null,
  selectedUser: null,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0,
  },
};
